import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import './PhoneInput.css';
import { getCountryCode } from '../../../helpers/common';
import cn from 'classnames';

export const PhoneInput = ({
  value,
  placeholder,
  onChange,
  onBlur,
  hasError,
  ...props
}) => {
  let countryCallingCodes = getCountries().map((country) => ({
    value: `+${getCountryCallingCode(country)}`,
    label: `+${getCountryCallingCode(country)}`,
  }));

  const countries = new Set();
  countryCallingCodes = countryCallingCodes.filter(
    ({ value: country }) => !countries.has(country) && countries.add(country),
  );

  const [newPhone, setNewPhone] = useState(
    getCountryCode(value)?.withoutCountryCode ?? '',
  );
  const [newPhoneCode, setNewPhoneCode] = useState(
    getCountryCode(value)?.countryCode ?? '',
  );

  useEffect(() => {
    onChange({
      value: newPhoneCode + newPhone,
    });
  }, [newPhone, newPhoneCode]);

  useEffect(() => {
    setNewPhone(getCountryCode(value)?.withoutCountryCode ?? '');
    setNewPhoneCode(getCountryCode(value)?.countryCode ?? '');
  }, [value]);

  return (
    <div className="phone-input">
      <div className="input">
        <Dropdown
          {...props}
          className={cn({ 'p-invalid': hasError })}
          options={countryCallingCodes}
          filter
          value={newPhoneCode}
          onBlur={onBlur}
          onChange={(e) => setNewPhoneCode(e.target.value)}
        />
        <InputText
          {...props}
          className={cn({ 'p-invalid': hasError })}
          keyfilter="int"
          value={newPhone}
          onInput={(e) => setNewPhone(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
